import { GetServerSideProps, NextPage } from 'next';
import { getDataHooksProps } from 'next-data-hooks';
import React from 'react';

import { ArticlePageTypes } from '../../../utils/_enums/article-page-types';
import { resolveLanguageAndRedirect } from '../../../utils/_helper/resolve-language-and-redirect-helper';
import { setHeaders } from '../../../utils/_helper/set-headers';
import { ArticlePage } from '../../../views/article-page/article-page';

const ArticleWithIdPage: NextPage = () => (
    <ArticlePage type={ArticlePageTypes.ARTICLE_PAGE_STRAPIID} />
);

export default ArticleWithIdPage;

export const getServerSideProps: GetServerSideProps = async (context) => {
    setHeaders(context);

    const redirect = await resolveLanguageAndRedirect(context);

    if (redirect) return { redirect };

    if (context.resolvedUrl === '/s/homepage' || context.resolvedUrl === '/s') {
        return {
            redirect: {
                destination: `/${context.locale ? context.locale+'/page/' : ''}`,
                permanent: false,
            },
        };
    }

    const dataHooksProps = await getDataHooksProps({
        context,
        dataHooks: ArticlePage.dataHooks
    });
    
    if (dataHooksProps.nextDataHooks['ArticlePage']) {
        return {
            props: { ...dataHooksProps }
        };
    } else {
        return {
            notFound: true
        };
    }
};
